import { render } from "./ExpandableDataTable.vue?vue&type=template&id=56b8795a"
import script from "./ExpandableDataTable.vue?vue&type=script&lang=js"
export * from "./ExpandableDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__